import "./style/App.scss";
import { BrowserRouter as Router, Routes, Route, matchPath } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Cart from "./pages/Cart";
import Product from "./pages/Product";
import ProductContextProvider from "./context/ProductContext";
import CartProvider from "./context/CartContext"; // Import the CartContext
import Login from "./pages/admin/Login";
import Signup from "./pages/admin/Signup";
import Checkout from "./pages/Checkout";
import UserContextProvider from "./context/UserContext";
import Dashboard from "./pages/admin/Dashboard";
import SoldProducts from "./pages/admin/SoldProducts";
import Userprofile from "./pages/admin/Userprofile";
import Orders from "./pages/admin/Orders";
import Products from "./pages/admin/Products";
import ScrollToTop from "./components/ScrollToTop";
import OrderDetails from "./pages/admin/OrderDetails";
import DummyPage from "./pages/DummyPage";
import Categories from "./pages/Categories";
import Category from "./pages/Category";
import Users from "./pages/admin/Users";
import Admins from "./pages/admin/Admins";
import SubCategories from "./pages/SubCategories";
import AllCategories from "./pages/admin/AllCategories";
import AllSubCategories from "./pages/admin/AllSubCategories";
import SuccessPage from "./pages/admin/SuccessPage";
import Structure from "./components/Admin/Structure";
import CommissionTable from "./components/Admin/CommissionTable";
import Inventory from "./components/Admin/Inventory";
import Adminproduct from "./components/Admin/Adminproduct";
import AdminAllOrder from "./components/Admin/AdminAllOrder";
import AdminOrderDetails from "./components/Admin/AdminOrderDetails";
import AllOrderOfSeller from "./components/AllOrderOfSeller";
import SellerOrderDetail from "./components/SellerOrderDetail";
import Contact from "./components/Admin/Contact";
import AdminAllSellerOrder from "./components/Admin/AdminAllSellerOrder";
import AdminAllSellerOrderDetail from "./components/Admin/AdminAllSellerOrderDetail";
import SellerId from "./components/Admin/SellerId";
import GstCatalogue from "./components/Admin/GstCatalogue";
import Forgotpassword from "./pages/admin/Forgotpassword";
import ChangePassword from "./pages/admin/ChangePassword";
import ResetPassword from "./pages/admin/ResetPassword";
import Cms from "./pages/admin/Cms";
import { Aboutus } from "./pages/Aboutus";
import { Terms } from "./pages/Terms";
import { Privicy } from "./pages/Privicy";
import { WhatWeDo } from "./pages/WhatWeDo";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { CmsProvider } from "./context/CmsContext";
import { SearchPage } from "./pages/SearchPage";
import PendingBalance from "./pages/admin/PendingBalance";
import WithDrawal from "./components/Admin/WithDrawal";
import PendingOrderDetail from "./pages/admin/PendingOrderDetail";
import { useLocation } from "react-router-dom";
import ReportPage from "./pages/admin/ReportPage";

function AppRoutes() {

  const location = useLocation();

  const hideRoutesNavigation = [
    "/dashboard",
    "/dashboard/soldproducts",
    "/pending-balance",
    "/pending-balance/:id",
    "/withdrawal",
    "/allorders",
    "/allorders/:id",
    "/allorderofseller",
    "/allorderofseller/:id",
    "/orders",
    "/orderDetails/:id",
    "/allsellerorderlist",
    "/allsellerorderlist/:id",
    "/allsellerorderlist/:id/:orderNumber",
    "/gst-catalogue",
    "/resetpassword",
    "/changepassword",
    "/userprofile",
    "/products",
    "/all-products",
    "/users",
    "/admins",
    "/tree",
    "/admin/tree-view/:username/:side",
    "/commission",
    "/inventory",
    "/addcategories",
    "/addsubcategories",
    "/cms",
    "/report",
  ];

  const isDashboardRoute = hideRoutesNavigation.some((path) =>
    matchPath({ path, end: false }, location.pathname)
  );

  return (
    <UserContextProvider>
      <Navbar />
      <CmsProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/dashboard/soldproducts"
            element={<SoldProducts />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/policy" element={<Privicy />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/pending-balance" element={<PendingBalance />} />
          <Route path="/pending-balance/:id" element={<PendingOrderDetail />} />
          <Route path="/withdrawal" element={<WithDrawal />} />
          <Route path="/allorders" element={<AdminAllOrder />} />
          <Route path="/allorders/:id" element={<AdminOrderDetails />} />
          <Route
            path="/allorderofseller"
            element={<AllOrderOfSeller />}
          />
          <Route
            path="/allorderofseller/:id"
            element={<SellerOrderDetail />}
          />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orderDetails/:id" element={<OrderDetails />} />

          <Route path="/allsellerorderlist" element={<SellerId />} />
          <Route
            path="/allsellerorderlist/:id"
            element={<AdminAllSellerOrder />}
          />
          <Route
            path="/allsellerorderlist/:id/:orderNumber"
            element={<AdminAllSellerOrderDetail />}
          />

          <Route path="/gst-catalogue" element={<GstCatalogue />} />

          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/changepassword" element={<ChangePassword />} />

          <Route path="/userprofile" element={<Userprofile />} />
          <Route path="/ordersuccess" element={<SuccessPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/all-products" element={<Adminproduct />} />
          <Route path="/users" element={<Users />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/tree" element={<Structure />} />
          <Route path="/admin/tree-view/:username/:side" element={<Structure />} />
          <Route path="/commission" element={<CommissionTable />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/addcategories" element={<AllCategories />} />
          <Route
            path="/addsubcategories"
            element={<AllSubCategories />}
          />
          <Route path="/dummyPage" element={<DummyPage />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/category/:name" element={<SubCategories />} />
          <Route
            path="/category/:categoryname/:subcategoryname"
            element={<Category />}
          />
          <Route
            path="/cms"
            element={<ProtectedRoute element={<Cms />} />}
          />
          <Route path="/report" element={<ReportPage />} />
        </Routes>
        {!isDashboardRoute && <Footer />}
      </CmsProvider>
    </UserContextProvider>
  )

}

function App() {

  return (
    <ProductContextProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
      </CartProvider>
    </ProductContextProvider>
  );
}

export default App;
